/* Breakpoints that match with globals.css so that we can use them in JS consistently */
/* If changing these, make sure globals.css values also match */

export const breakpoints = /** @type {const} */ ({
	/* 480px */
	minSmall: {
		query: '(min-width: 30rem)',
		pixel: 480,
	},
	/* 768px */
	minMedium: {
		query: '(min-width: 48rem)',
		pixel: 768,
	},
	/* 1024px */
	minLarge: {
		query: '(min-width: 64rem)',
		pixel: 1024,
	},
	/* 1366px */
	minXLarge: {
		query: '(min-width: 85.375rem)',
		pixel: 1366,
	},
	/* 1600px */
	minXXLarge: {
		query: '(min-width: 100rem)',
		pixel: 1600,
	},
});
